import React from 'react'
import { useParams } from 'react-router-dom'
import { INDEXING_STATUS } from '@trustero/trustero-api-web/lib/common/model_pb'
import { BrokenLinkIcon } from 'src/components/Icons/Basic/BrokenLinkIcon'
import { DirectRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { useIndexingStatusPage } from 'src/context/Gatekeeper'
import { Tooltip } from 'src/components/Reusable/Tooltip'
import { TooltipPositions } from 'src/components/Reusable/Tooltip/Tooltip'

export const isIndexingFailed = (status?: INDEXING_STATUS): boolean =>
  status === INDEXING_STATUS.INDEXING_STATUS_FAILED

/**
 * FailedIndexingIcon replaces an evidence/policy-document row's file-type
 * icon when content indexing has failed. The row itself is greyed out by
 * the caller (via the grid's disabled-row prop), mirroring the "broken
 * link" treatment. On hover it surfaces "Indexing failed." plus a
 * "Learn more" link to the in-app indexing status page (only when that
 * page is enabled for the account).
 */
export const FailedIndexingIcon = ({ id }: { id: string }): JSX.Element => {
  const params = useParams()
  const indexingPageEnabled = useIndexingStatusPage()
  const learnMoreHref = indexingPageEnabled
    ? params.pageContext
      ? `/${params.pageContext}/${DirectRoutes.INDEXING}`
      : `/${DirectRoutes.INDEXING}`
    : undefined

  return (
    <Tooltip
      id={`indexing-failed-${id}`}
      placement={TooltipPositions.top}
      tooltipBody="Indexing failed."
      learnMoreHref={learnMoreHref}
    >
      <span>
        <BrokenLinkIcon />
      </span>
    </Tooltip>
  )
}
